import { ReactComponent as LogoUsIgnite } from 'assets/img/logo-us-ignite.svg';
import { ROUTE_PATHS } from 'routes';
import { Link as ReactLink } from 'react-router-dom';

export default function PageHeader() {
  return (
    <div className='flex items-center h-12 gap-5 px-5 bg-blue-500'>
      <a
        href='https://www.us-ignite.org/'
        target='_blank'
        rel='noopener noreferrer'
        className='w-24'
      >
        <LogoUsIgnite className='w-full' />
      </a>

      <ReactLink to={ROUTE_PATHS.SPLASH}>
        <div className='text-white-400 text-md -translate-y-[0.5px]'>
          <span className='font-bold'>Data Tools</span> Broadband
        </div>
      </ReactLink>
    </div>
  );
}
